<template>

  <div>
    <v-icon class="mr-1 icon-download" color="primary">mdi-download</v-icon>
    <a :href="downloadPageUri" class="download-link" title="Download Manifest" target="_new">Download Manifest</a>
  </div>

</template>

<script>
export default {
  name: 'RouteManifestDownload',

  props: {
    routeId: {
      type: String,
      required: true
    }
  },

  computed: {
    downloadPageUri () {
      const host = (window) ? `${window.location.protocol}//${window.location.host}` : 'localhost'
      return `${host}/download/route/${this.routeId}`
    }
  }
}
</script>

<style scoped>
  a.download-link {
    text-decoration: none;
  }

  a.download-link:hover {
    text-decoration: underline;
  }
</style>
